import React, { useState, useEffect } from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import List from "../../components/List";
import Modal from "../../components/Modals/Modal";
import { Button, Input, MenuSelect } from "../../components/Form";
import { FaSave } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdAdd } from "react-icons/md";
import { useAppSelector, useAppDispatch } from '../../store';

import { getAllLabMaterials, createLabMaterial } from "../../api/labMaterial";
import { toast } from 'react-toastify';
import Loader from "../../components/Loader";

function Materials() {
	const userData = useAppSelector((state) => state.userData);

	const [modal, setModal] = useState(false);
	const [dropdown, setDropdown] = useState(false);
	const data = [{ name: "ml" }, { name: "dl" }, { name: "g" }, { name: "#" }];

	const [labMaterials, setLabMaterials] = useState([]);
	const [name, setName] = useState("");
	const [code, setCode] = useState("");
	const [unit, setUnit] = useState("#");
	const [description, setDescription] = useState("");
	const [pageLoader, setPageLoader] = useState(true);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		console.log(userData)
		const fetchData = async () => {
			const res = await getAllLabMaterials({ labId: userData?.user?.defaultLabId });
			setLabMaterials(res);
			setPageLoader(false);
			console.log(res);
		};

		if (userData?.user?.defaultLabId) {
			fetchData();
		} else {
			setPageLoader(false);
		}
	}, [userData, modal]);

	const handleSave = async () => {
		if (!name.trim()) {
			toast.error("Name is required");
			return;
		}

		const data = {
			labId: userData?.user?.defaultLabId,
			name: name,
			code: code,
			unit: unit,
			description: description,
		};

		setLoading(true);
		const response = await createLabMaterial(data);
		if (response) {
			setLoading(false);
			setModal(false);
			setName("");
			setCode("");
			setUnit("#");
			setDescription("");
		}

		setLoading(false);
	}

	return (
		<Layout>
			{
				pageLoader ? <Loader /> :
					<>
						{
							labMaterials.length === 0 ?
								<div className="text-center text-lg my-4">
									No Materials Found
								</div>
								:
								<Container className={"flex flex-1 flex-col divide-y rounded-xl "}>
									<List list={labMaterials} path={"materials"} />
								</Container>
						}
						<div className="flex justify-center items-center my-2">
							<Button
								className={"w-52 max-w-fit px-5"}
								label={"Add New Material"}
								Icon={() => <MdAdd size={22} />}
								onClick={() => setModal(true)}
							/>
						</div>
						<Modal isOpen={modal} closeModal={() => setModal(false)} title={"New Material"}>
							<Input label={"Name *"} placeholder={"Name"} color={true} value={name} onChange={(e) => setName(e.target.value)} />
							<Input label={"Code "} placeholder={"Code"} color={true} value={code} onChange={(e) => setCode(e.target.value)} />
							<div className="" onClick={() => setDropdown(!dropdown)}>
								<MenuSelect
									className={"my-2"}
									datas={data}
									onClick={(e) => { setUnit(e.name); }}
									isMenuOpen={dropdown}
									setIsMenuOpen={setDropdown}
									staticMode>
									<div className="flex flex-1 flex-col">
										<div className="flex flex-1 w-full">Unit *</div>
										<div className="flex flex-1 justify-between">
											<span>{unit}</span>
											<MdKeyboardArrowDown className="text-lg" />
										</div>
									</div>
								</MenuSelect>
							</div>
							<Input label={"Description"} placeholder={"Description"} color={true} value={description} onChange={(e) => setDescription(e.target.value)} />
							<Button className={"my-4"} label={"Save"} Icon={FaSave} onClick={handleSave} loading={loading} />
						</Modal>
					</>
			}
		</Layout>
	);
}

export default Materials;
